module.exports = __webpack_public_path__ + "static/media/Rossmann_Medium.017ed484.woff2";